import { z } from 'zod';

export type UpdateTeamPayload = z.infer<typeof updateTeamPayloadSchema>;

export const updateTeamPayloadSchema = z.object({
  name: z.string().min(1).optional(),
});
